import { parsePhoneNumber } from 'libphonenumber-js';
import { RegionType } from 'models';

export function getCountryCode(phoneNumber: string) {
	const defaultResult = RegionType.WA;
	if (!phoneNumber) return defaultResult;

	return parsePhoneNumber(phoneNumber)?.countryCallingCode as string;
}
